var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutforDelivery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10342",
    "data-name": "Group 10342",
    transform: "translate(-29.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_268",
    "data-name": "Ellipse 268",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(29.5)",
    fill: "#313d85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M19096.3,22702.615a1.312,1.312,0,0,1-1.311-1.314v-2.625h-15.744v2.625a1.316,1.316,0,0,1-1.314,1.314h-1.307a1.316,1.316,0,0,1-1.314-1.314v-2.705a1.461,1.461,0,0,1,.051-.254,2.612,2.612,0,0,1-1.359-2.287v-6.561a2.617,2.617,0,0,1,1.605-2.414l1.795-5.389a3.937,3.937,0,0,1,3.734-2.689h11.959a3.937,3.937,0,0,1,3.734,2.689l1.795,5.389a2.62,2.62,0,0,1,1.613,2.414v6.561a2.628,2.628,0,0,1-1.367,2.287,1.069,1.069,0,0,1,.053.254v2.705a1.311,1.311,0,0,1-1.309,1.314Zm-19.676-6.561h20.99v-6.561h-20.99Zm3.264-13.533-1.447,4.348h17.352l-1.451-4.348a1.309,1.309,0,0,0-1.246-.9h-11.959A1.313,1.313,0,0,0,19079.891,22682.521Zm12.473,10.252a1.97,1.97,0,1,1,1.975,1.973A1.97,1.97,0,0,1,19092.363,22692.773Zm-14.43,0a1.969,1.969,0,1,1,1.973,1.973A1.968,1.968,0,0,1,19077.934,22692.773Z",
    transform: "translate(-19025.125 -22658.313)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutforDelivery);
export default __webpack_public_path__ + "static/media/Out for Delivery.3cec310cbc1b0764d3dd9f8a6944f9c0.svg";
export { ForwardRef as ReactComponent };